<template>
  <div>
    <div class="info-form">
      <img class="info-person"
           src="../assets/images/login/img_login_person.png"
           alt />
      <div class="form-main">
        <h5 class="form-perfect">
          完善信息
          <span>
            【注：
            <i>*</i> 为必填项】
          </span>
        </h5>

        <Form @submit.prevent>

          <div class="form-cell2 wx-box"
               v-if="flagOfWechat">
            <label class="form-label form-required">绑定微信</label>
            <div class="form-input">
              <Input class="form-wechat"
                     readonly
                     v-model="info.wechat"
                     placeholder
                     style="width: 235px">
              <img class="form-icon"
                   @click="bindWechat"
                   src="../assets/images/personal/icon_wechat.png"
                   slot="suffix" />
              </Input>
            </div>
            <span style="font-size: 12px;color: #9B9898; margin-left: 10px;">点击
                <img style="background: #85bf76;width: 15px;height: 15px;" src="../assets/images/personal/icon_wechat.png"/>
                ，扫码绑定</span>
          </div>
          <div class="form-cell2" @click="bindWachat">
            <label class="form-label form-required">真实姓名</label>
            <div class="form-input">
              <Input v-model="info.name"
                     placeholder
                     :disabled="!info.wechat"
                     style="width: 400px" />
            </div>
          </div>
          <div class="form-cell2" @click="bindWachat">
            <label class="form-label form-required">身份证号</label>
            <div class="form-input">
              <Input v-model="info.id_number"
                     placeholder
                     :disabled="!info.wechat"
                     style="width: 400px" />
            </div>
          </div>
          <div class="form-cell2" @click="bindWachat">
            <label class="form-label">E-mail</label>
            <div class="form-input">
              <Input v-model="info.email"
                     placeholder
                     :disabled="!info.wechat"
                     style="width: 400px" />
            </div>
          </div>
          <div class="form-cell2" @click="bindWachat">
            <label class="form-label form-required">设定密码</label>
            <div class="form-input">
              <Input v-model="info.password"
                     type="password"
                     placeholder
                     :disabled="!info.wechat"
                     style="width: 400px" />
            </div>
          </div>
          <div class="form-cell2" @click="bindWachat">
            <label class="form-label form-required">确认密码</label>
            <div class="form-input">
              <Input v-model="info.confirm_password"
                     type="password"
                     placeholder
                     :disabled="!info.wechat"
                     style="width: 400px" />
            </div>
          </div>
        </Form>
        <button class="btn"
                :disabled="subBtn"
                @click="submitInfo('infolist')">提交</button>
      </div>
    </div>
    <!-- 判断显示绑定手机号  @on-ok="ok" @on-cancel="cancel"-->
    <Modal :value="flagOfPhone"
           title="绑定手机号"
           :mask-closable="false"
           :closable="false">
      <div class="form-cell2 code-box">
        <label class="form-label form-required">绑定手机号</label>
        <div class="form-input">
          <Input v-model="info.phone"
                 @on-keyup="typingNumber"
                 placeholder
                 style="width: 260px" />
          <Button class="codeBtn"
                  type="default"
                  @click="getCode"
                  :disabled="codes.disabled">{{btnText}}</Button>
        </div>
      </div>
      <div class="form-cell2">
        <label class="form-label">验证码</label>
        <div class="form-input">
          <Input v-model="info.code"
                 placeholder
                 style="width: 400px" />
        </div>
      </div>
      <div slot="footer">
        <button class="btn"
                style="width: 180px"
                @click="registUserByPhone">绑定手机号</button>
      </div>
    </Modal>
    <Modal v-model="qrCodeModel" :footer-hide="true" @on-cancel="getInfo">
      <div class="code_content">
        <img class="qr_code" :src="demo" alt="">
        请使用微信扫描上方二维码。
        关注公众号后，再关闭本页面。
      </div>
    </Modal>
    <Modal v-model="htModel" :footer-hide="true" :closable="false" :mask-closable="false" width="1012" @on-cancel="agreeThisRule">
      <div class="agreement">
        <div class="page-wrap">
          <div class="page-content">
            <h5 class="agree-title">{{title}}</h5>
            <div class="agree-con"
                 v-html="rules"></div>
          </div>
        </div>
        <p class="agree-wrap">
          <Checkbox v-model="agree">我已阅读并同意上述内容</Checkbox>
        </p>
        <button class="button-order"
                @click="agreeThisRule">同意</button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from '@/api/axios.js';
import * as apis from "@/api/login.js";
import * as apio from '@/api/other';
import { setLocalStorage, getLocalStorage } from '@/utils/tools.js'
import {
  verifyPhone,
  verifyEmail,
  verifyPassword
} from "../../public/js/util.js";
import { setInterval, clearInterval } from "timers";
import demo from '@/assets/images/vip/qrcode.jpg';

export default {
  data () {
    return {
      btnText: "获取验证码",
      subBtn: false,
      codes: {
        disabled: true,
        time: 10,
        timer: null
      },
      flagOfPhone: false,
      flagOfWechat: true,
      uid: undefined,
      info: {
        name: "",
        password: "",
        confirm_password: "",
        id_number: "",
        phone: "",
        code: "",
        email: "",
        wechat: ""
      },
      qrCodeModel: false,
      htModel: false,
      agree: false,
      htFlag: false,
      rules: '',
      title: '',
      demo,
    };
  },
  computed: {
    sendCode () {
      if (!this.codes.disabled) {
        return this.countBackwordNumber(this.codes);
      } else {
        return this.codes;
      }
    }
  },
  async mounted () {
    // let code = localStorage.getItem('code');
    // if (code == 222) {
    //   this.flagOfPhone = true;
    // } else {
    //   this.flagOfPhone = false;
    // }
    //通过微信返回的code再获取基础信息
    let query = this.$route.query;
    if (Object.keys(query).length > 0) {
      this.sendCodeToLogin(query.code, query.state);
    }
    setTimeout(() => {
      this.getInfo();
    }, 1000)
    this.getAgreementContent();
  },
  methods: {
    async getInfo() {
      console.log('getInfo')
      let token = getLocalStorage("token");
      let temp = JSON.parse(localStorage.getItem("temp")) || {};
      let res = await apis.getUserInfoData({ token });
      if (res.code === 200) {
        if (res.data.nickName) {
          if (!res.data.subscribe) {
            this.qrCodeModel = true
          }
        } else {
          this.htModel = true
        }
        this.info.name = res.data.name || temp.name;
        // this.info.phone = res.data.phone || temp.phone;
        // this.info.email = res.data.email || temp.email;
        this.info.wechat = res.data.nickName || temp.nickName;
        // this.info.id_number = res.data.id_number || temp.id_number;
        // this.uid = res.data.id;
        localStorage.setItem('username', this.info.name || '')
      }
    },

    async getAgreementContent () {
      try {
        let data = {
          id: 1
        }
        let res = await apio.getUserAgreementsRuls(data);
        if (res.code == 200) {
          this.rules = res.data.content;
          this.title = res.data.name;
        }
      } catch (e) {
        console.log(e)
      }
    },
    agreeThisRule () {
      if (!this.agree) {
        this.$Message.error('您没有同意该协议，不能进行下一步！');
        return false;
      }
      this.htFlag = true;
      this.htModel = false;
    },
    registUserByPhone () {
      if (this.info.code == "" || this.info.phone.length != 11) {
        this.$Message.error("请输入手机号或验证码");
        return;
      }
      let data = {
        phone: this.info.phone,
        code: this.info.code
      }
      axios({
        method: "post",
        url: '/api/v1/web/register/sms/login',
        headers: {
          Authorization: "Basic ZW9sOmVvbFNlY3JldA=="
        },
        data: data
      }).then(res => {
        let token = null;
        if (res.code == 200) {
          token = res.data.token;
          setLocalStorage('token', token)
          setLocalStorage('loginState', true);
          localStorage.setItem('time', new Date().getTime());
          this.$store.commit('LOGIN_STATE', true);
          this.flagOfPhone = false;
          localStorage.setItem('code', 'success')
          //获取个人信息
        } else {
          this.$Message.error(res.msg);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    async getLoginOnPersonInfo (token) {
      try {
        let temp = JSON.parse(localStorage.getItem("temp"));
        let token = getLocalStorage("token");
        let res = await apis.getUserInfoData({ token });
        if (res.code == 200) {

          if (res.data.wechat == null) {
            this.flagOfWechat = true;
          } else {
            this.flagOfWechat = false;
          }
          console.log('getToken')
          // this.info.name = res.data.name || temp.name || '用户';
          // this.info.phone = res.data.phone || temp.phone;
          // this.info.email = res.data.email || temp.email;
          this.info.wechat = res.data.nickName || temp.nickName;
          // this.info.id_number = res.data.id_number || temp.id_number;
          // this.uid = res.data.id;
          localStorage.setItem('username', res.data.name || temp.name || '用户')
          // this.getInfo();
        }
      } catch (e) {
        console.log(e)
      }
    },
    bindWechat () {
      let temp = { ...this.info };
      localStorage.setItem("temp", JSON.stringify(temp));
      let redirect_uri = encodeURIComponent(
        "http://weimajie.com.cn/perfectInfo"
      );
      window.location.replace(
        "https://open.weixin.qq.com/connect/qrconnect?appid=wx6842a7f406c7d13f&redirect_uri=" +
        redirect_uri +
        "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
      );
      let str = "https://open.weixin.qq.com/connect/qrconnect?appid=wx6842a7f406c7d13f&redirect_uri=" +
        redirect_uri +
        "&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect&uid=" +
        this.uid;

      var obj = new WxLogin({
        id: "qrCode",
        appid: "wx6842a7f406c7d13f",
        scope: "snsapi_login",
        redirect_uri: "",
        href: "",
        state: ""
      });
    },
    async sendCodeToLogin (code, state) {
      let data = {
        code,
        state
      };
      let res = await apis.sendCodeToBind(data);
      if (res.code == 111) {
        this.$Message.error("该微信号已被注册过！");
        return;
      }
      if (res.code == 200) {
        let token = res.data.token;
        getLocalStorage("token", token)
        setLocalStorage("loginState", true);
        localStorage.setItem("time", new Date().getTime());
        this.$store.commit("LOGIN_STATE", true);
        this.getLoginOnPersonInfo(token);
      } else {
        this.$Message.error(res.data.msg[0]);
      }
    },
    countBackwordNumber (obj) {
      const TIME_COUNT = 10;
      if (!obj.timer) {
        obj.time = TIME_COUNT;
        obj.disabled = false;
        obj.timer = setInterval(() => {
          if (obj.time > 0 && obj.time <= TIME_COUNT) {
            obj.time--;
            this.btnText = obj.time + "s后重新获取";
            obj.disabled = true;
          } else {
            obj.disabled = false;
            clearInterval(obj.timer);
            this.btnText = "获取验证码";
            obj.timer = null;
          }
        }, 1000);
      }
      return {
        timer: obj.timer,
        disabled: obj.disabled,
        time: obj.time
      };
    },
    typingNumber () {
      //输入手机号
      let phone = this.info.phone;
      let flag = verifyPhone(phone);
      console.log(flag);
      if (flag) {
        this.codes.disabled = false;
      } else {
        this.codes.disabled = true;
      }
    },
    typingCode () {
      //输入验证码
      if (this.info.code.length > 0 && this.info.phone.length == 11) {
        this.subBtn = false;
      } else {
        this.subBtn = true;
      }
    },
    async getCode () {
      try {
        let phone = this.info.phone;
        let flag = verifyPhone(phone);
        if (!flag) {
          this.$Message.error("手机号格式不正确！");
          return false;
        }
        this.countBackwordNumber(this.codes);

        let data = {
          phone: phone
        };
        let res = await apis.perfectPersonCode(data);
        if (res.code == 200) {
          this.info.wechat = res.data.nickName;
          this.$Message.success({
            content: res.data.mobile,
            duration: 3
          });
          let token = getLocalStorage("token");
          this.getLoginOnPersonInfo(token);
        } else {
          this.$Message.error({
            content: res.data.phone[0],
            duration: 3
          });
          this.$router.push({
            name: 'login',
            params: {
              type: 1
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    bindWachat() {
      if (!this.info.wechat) {
        this.$Message.error("请先绑定微信");
        return false;
      }
    },
    async submitInfo () {
      let info = this.info;
      if (info.name == "") {
        this.$Message.error("真实姓名不能为空！");
        return false;
      }
      if (info.name.length < 2) {
        this.$Message.error("真实姓名格式不正确！");
        return false;
      }
      if (info.id_number.length != 18) {
        this.$Message.error("身份证号格式不正确！");
        return false;
      }
      if (info.wechat == "") {
        this.$Message.error("微信号不能为空！");
        return false;
      }

      if (this.flagOfPhone) {
        if (info.phone == "") {
          this.$Message.error("手机号不能为空！");
          return false;
        }
      }
      if (info.email) {
        if (!verifyEmail(info.email)) {
          this.$Message.error("邮箱格式不正确！");
          return false;
        }
      }

      if (info.password == "") {
        this.$Message.error("请设定密码！");
        return false;
      }
      if (!verifyPassword(info.password)) {
        this.$Message.error("密码为6-12位字母和数字组成！");
        return false;
      }
      if (info.confirm_password == "") {
        this.$Message.error("请输入确认密码！");
        return false;
      }
      if (info.password != info.confirm_password) {
        this.$Message.error("确认密码和设定密码不一致！");
        return false;
      }
      try {
        let data = this.info;
        let res = await apis.perfectPersonInfo(data);
        if (res.code == 200) {
          this.$Message.success({
            content: "信息完善成功！",
            duration: 3
          });
          let token = getLocalStorage("token");
          this.getLoginOnPersonInfo(token);
          console.log("完善成功！");
          if (localStorage.getItem('routePath')) {
            let name = localStorage.getItem('routePath') + ''
            this.$router.push(name)
            localStorage.setItem('routePath', '')
          } else {
            this.$router.push("/home");
          }

        } else {
          let str = "";
          for (let key in res.data) {
            str += res.data[key];
          }
          this.$Message.success({
            content: str,
            duration: 3
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.info-form {
  position: relative;
  width: 970px;
  min-height: 500px;
  background: #fff;
  border-radius: 8px;
  margin: 80px auto 180px;
  padding: 40px 0;
}
.info-person {
  position: absolute;
  right: 0;
  top: 0;
  background: #f4f4f4;
}
.form-main {
  width: 540px;
  margin: 0 auto;
}
.form-perfect {
  font-size: 30px;
  color: #ac4126;
  line-height: 40px;
  font-weight: normal;
  margin-bottom: 40px;
  span {
    font-size: 20px;
    color: #333130;
    i {
      color: #ac4126;
      font-style: normal;
    }
  }
}
.form-cell2 {
  margin-bottom: 26px;
}
.form-label {
  display: inline-block;
  width: 130px;
  font-size: 20px;
  color: #333130;
  line-height: 50px;
}
.form-required::after {
  float: right;
  display: inline-block;
  content: '*';
  font-size: 22px;
  color: #ac4126;
  line-height: 50px;
  margin-right: 20px;
}
.btn {
  width: 100%;
  height: 50px;
  color: #fff;
  background: #ac4126;
  font-size: 20px;
  border: none;
  border-radius: 4px;
}
.form-icon {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 60px;
  height: 44px;
  background: #85bf76;
  box-sizing: border-box;
  cursor: pointer;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 8px 14px;
  box-sizing: border-box;
}
.ivu-input-group {
  display: inline-table;
  top: 0;
}
.code-box {
  position: relative;
}
.codeBtn {
  position: absolute !important;
  top: 0px !important;
  right: 0px !important;
  width: 140px;
  height: 44px !important;
  background: #ac4126;
  color: #fff;
  font-size: 14px;
  border: none !important;
  vertical-align: top;
  // border-top-left-radius: 0;
  // border-bottom-left-radius: 0;
  border-left: 2px solid #ddd !important;
}
.form-input {
  display: inline-block;
  vertical-align: middle;
  border: 2px solid #ddd;
  border-radius: 4px;
}
.wx-box {
  position: relative;
}
</style>
<style>
.form-wechat .ivu-input {
  padding-right: 72px;
}
.form-wechat .ivu-input-suffix {
  width: 60px;
  height: 50px;
}
.form-cell2 .ivu-input {
  height: 50px;
  background: #f4f4f4;
  font-size: 18px;
  border: none;
  border-radius: 0;
}
.code_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
  .qr_code {
    width: 200px;
    height: 200px;
  }

.page-wrap {
  width: 970px;
  background: #fff;
  border: 1px solid #dcdcdc;
  margin: 0 auto 30px;
  padding-bottom: 34px;
}
.page-headline {
  position: relative;
  width: 100%;
  height: 10px;
  background: #333130;
}
.page-headline::before {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 440px;
  height: 10px;
  background: #ae1e10;
  content: '';
}
.agree-title {
  font-size: 30px;
  color: #302e2e;
  line-height: 116px;
  text-align: center;
}
.agree-con {
  width: 860px;
  margin: 0 auto;
}
.button-order {
  width: 400px;
  border-radius: 4px;
  margin: 20px auto 54px;
}
.agree-wrap {
  width: 970px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 30px;
}
</style>

